// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"261":"cf5f309a","312":"7c02fffd","455":"1d22e15a","977":"65f5038c"}[chunkId] + ".chunk.js";
};